"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Yup = __importStar(require("yup"));

var yupString = Yup.string();

Yup.string.prototype.isPassword = function (message) {
  return Yup.string().test("isPassword", message, function (value) {
    var small = /[a-z]/.test(value);
    var upper = /[A-Z]/.test(value);
    var digit = /[\d]/.test(value);
    var other = /[\W]/.test(value);
    return small && upper && digit && other;
  });
};

Yup.string.prototype.match = function (field, message) {
  return Yup.string().test("match", message, function (value) {
    var that = _this;
    if (!that.parent) return;
    return that.parent[field] === value;
  });
};

Yup.string.prototype.isRef = function (message) {
  return Yup.string().test("reference", message, function (value) {
    var isLength = value && value.replace(/(\s|,|-|\.)/gi, "").length === 12;
    var startW98 = /^98/.test(value);
    return isLength && startW98;
  });
};